module.exports = __webpack_public_path__ + "static/media/Melissa2_preview.a8157a22.jpg";